module.exports = require('./helpers/bundle-url').getBundleURL('drLhz') + "../assets/images/hu.8810d3ea.webp";